import React, { useState } from "react";
import { ListChecks } from "lucide-react";
import { useAuth } from "../lib/AuthContext";
import ShortlistBundlePicker from "./ShortlistBundlePicker";

/**
 * v2.71.13 — Card-level CTA. Renders only for admin/team viewers.
 * Opens a bundle picker that adds the property to an existing or new bundle.
 *
 * Visibility rules (per scoping):
 *   • admin / team_member → visible
 *   • client / dealer / builder / anonymous → hidden (no-op render)
 */
export default function AddToShortlistButton({ propertyId, propertyTitle, compact = false }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  const isStaff = user && (user.role === "admin" || user.role === "team");
  if (!isStaff) return null;

  return (
    <>
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
        title="Add to a shortlist bundle"
        className={
          compact
            ? "inline-flex items-center justify-center w-7 h-7 rounded-sm bg-white/90 hover:bg-white border border-[#E4E4E7] hover:border-[#16A34A] text-[#15803D] transition-colors"
            : "inline-flex items-center gap-1 px-2 py-1 rounded-sm border border-[#E4E4E7] hover:border-[#16A34A] hover:bg-[#F0FDF4] text-[12px] text-[#15803D] transition-colors"
        }
        data-testid={`add-to-shortlist-${propertyId}`}
      >
        <ListChecks size={compact ? 13 : 12} />
        {!compact && <span>Shortlist</span>}
      </button>
      <ShortlistBundlePicker
        open={open}
        onClose={() => setOpen(false)}
        propertyId={propertyId}
        propertyTitle={propertyTitle}
      />
    </>
  );
}
